import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { BoothModel } from 'src/app/models';
import { BoothService, GoogleService, ModalService, StateService } from 'src/app/services';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
    public headerVisible: boolean = true;
    public headerOpen: boolean = false;
    public data: Array<any> = [];
    public currentPage: string = '/';
    public withHotspots: boolean = false;
    public onMedicalPage: boolean = false;
    public jsonData: BoothModel;

    constructor(
        private modalSvc: ModalService,
        private stateSvc: StateService,
        private boothSvc: BoothService,
        private router: Router,
        private googleSvc: GoogleService
    ) {
        router.events.subscribe((val) => {
            if (val instanceof NavigationEnd) {
                this.currentPage = val.url;
                this.onMedicalPage = val.url === '/medical-info';
                if (this.onMedicalPage) {
                    this.router.navigateByUrl('/');
                }
            }
        });
    }

    ngOnInit(): void {
        this.subscribe();
        this.setMenuItems();
    }

    public setMenuItems(): void {
        this.data.push({
            text: 'Welcome Center',
            url: '/',
            id: 1
        });

        this.jsonData.booths.forEach(el => {
            if (el.menu_text !== '') {
                this.data.push({
                    text: el.menu_text,
                    url: el.url,
                    id: el.id,
                    name: el.name
                });
            }
        });
    }

    public subscribe(): void {
        this.stateSvc.headerOpen.subscribe(data => {
            this.headerOpen = data;
        });
        this.boothSvc.boothDataUpdated.subscribe(data => {
            if (data) {
                this.jsonData = this.boothSvc.boothModel;
            }
        });
    }

    public toggleHeader(): void {
        this.headerOpen = !this.headerOpen;
        this.googleSvc.sendGAEventById(9, { category: this.headerOpen ? 'open' : 'close' });
        this.stateSvc.setHeaderOpen(this.headerOpen);
    }

    public goToCenter(): void {
        this.headerOpen = false;
        this.stateSvc.setHeaderOpen(this.headerOpen);
        this.stateSvc.setState(this.stateSvc.states.CENTER);
        this.sendTracking('Return to Products');
    }

    public linkClick(link: any): void {
        this.headerOpen = false;
        this.sendTracking(link.text);

        setTimeout(() => {
            if (link.id) {
                if (link.id === this.stateSvc.states.MED_INFO) {
                    this.modalSvc.setActiveModalById('leaving-medical');
                } else {
                    this.stateSvc.setState(link.id);
                }
            } else if (link.href) {
                window.open(link.href);
            }

            this.stateSvc.setHeaderOpen(this.headerOpen);
        }, 350);
    }

    sendTracking(text: string = ''): void {
        this.googleSvc.sendGAEventById(3, { label: text, category: 'menu' });
    }
}
